// service
import FormatService from 'modules/Format';

export const updateDocumentTitle = (
  exchangeToken: string,
  displayName: string,
  lastTradedPrice?: string,
  closePrice?: string,
) => {
  let title = displayName || 'Upstox';
  if (lastTradedPrice && closePrice) {
    const lastTradedPriceFD = lastTradedPrice.split('.')[1];
    const digitsAfterDot = FormatService.getDigitsAfterDot(exchangeToken);
    const ltpChange = FormatService.getDiff(lastTradedPrice, closePrice, {
      fractionDigits: lastTradedPriceFD ? lastTradedPriceFD?.length : undefined,
      showValue: 'number',
      showSign: true,
    });
    const percentageChange = Number(lastTradedPrice) === 0
      ? FormatService.setFractionDigits(
        Number(lastTradedPrice),
        lastTradedPriceFD?.length || 2,
      )
      : FormatService.getDiff(lastTradedPrice, closePrice, {
        showValue: 'percentage',
      });
    const formattedLTPChange = FormatService.formatToIndianPrice(ltpChange);
    const formattedLtp = FormatService.formatToIndianFloat(
      lastTradedPrice, digitsAfterDot,
    );
    const percentageValue = FormatService.getPercentageValue(
      formattedLTPChange, percentageChange,
    );

    title += ` ${formattedLtp} ${Number(percentageValue) > 0 ? '▲' : '▼'} ${percentageValue.toFixed(2)}%`;
  }

  document.title = title;
};
